
const Reports = ({ navigate, user }) => {
    return (
        <>
            <h1>Relatórios</h1>
        </>
    )
}

export default Reports;